import { Button, Flex, Paper, Stack, Text } from '@mantine/core';
import { useSuspenseQuery } from '@tanstack/react-query';
import { Outlet, createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { getEvaluationCriteriaOptions } from '@/module/Evaluation/model/EvaluationQuery';

export const Route = createFileRoute(
  '/_auth/evaluation/_layout/$evaluationId/_layout/report/gather/_gather/$orderNo/_layout',
)({
  component: RouteComponent,
});

function RouteComponent() {
  const { evaluationId, orderNo } = Route.useParams();
  const { t } = useTranslation();

  const { data: criteria } = useSuspenseQuery(getEvaluationCriteriaOptions(evaluationId));
  const index = criteria.map(c => c.orderNo).indexOf(Number(orderNo));
  const template = criteria[index];

  const navigate = Route.useNavigate();
  const next = () =>
    navigate({
      to: `/evaluation/$evaluationId/report/gather/$orderNo`,
      params: { evaluationId, orderNo: String(criteria[index + 1].orderNo) },
      search: true,
    });

  const prev = () =>
    navigate({
      to: `/evaluation/$evaluationId/report/gather/$orderNo`,
      params: { evaluationId, orderNo: String(criteria[index - 1].orderNo) },
      search: true,
    });

  return (
    <Stack>
      <Paper p="sm">
        <Flex
          mb="15px"
          align="center"
          justify="space-between"
        >
          <Button
            miw="70px"
            size="xs"
            onClick={prev}
            disabled={index === 0}
          >
            Înapoi
          </Button>
          <Text px="7px">
            {t(`evaluation.category.${template.category}`)} - Nr. crt: {template.orderNo} / {criteria.length}
          </Text>
          <Button
            miw="90px"
            size="xs"
            onClick={next}
            disabled={index == criteria.length - 1}
          >
            Următorul
          </Button>
        </Flex>
        <div>
          <Text
            px="7px"
            fw="500"
            size="lg"
          >
            {template.title}
          </Text>
          <Text
            px="7px"
            c="dimmed"
            fs="italic"
          >
            {template.legend}
          </Text>
          {orderNo === '77' && (evaluationId === '2' || evaluationId === '3') && (
            <Text c="red">
              Se acceptă maximum 5 recenzii publicate în aceeași revistă. Indiferent de tipul revistei, nu se pot
              cuantifica mai mult de 20 de recenzii pe an, dovedite prin sistem editorial (Editorial Manager), diplomă
              de reviewer, sau email oficial cu confirmarea efectuării recenziei sau cu certificat de reviewer (pentru
              revistele UMFST se multiplică cu 1,5)
            </Text>
          )}
        </div>
      </Paper>
      <Outlet />
    </Stack>
  );
}
